import { render, staticRenderFns } from "./ProjectCoach.vue?vue&type=template&id=13275b61&scoped=true"
import script from "./ProjectCoach.vue?vue&type=script&lang=js"
export * from "./ProjectCoach.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=13275b61&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13275b61",
  null
  
)

export default component.exports